import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@sopranodesign/pulse-hooks';
import { Select } from '@sopranodesign/pulse-components';

const format = ({ id, content }) => ({
  value: id,
  label: content.name
});

const SectionSelect = ({ value, import: item, ...props }) => {
  const {
    data,
    isLoading,
    isSuccess
  } = useQuery({
    queryKey: [
      'imports'
    ]
  });

  const disabled = !item;

  const sections = useMemo(() => {
    if (!item || !isSuccess) {
      return null;
    }

    const selected = data.data.find(({ id }) => id === item);

    return selected ? selected.sections : null;
  }, [data, isSuccess, item]);

  const selectedSection =
    sections && value
      ? sections.find(section => section.id === value)
      : null;

  return (
    <Select
      isLoading={isLoading}
      isDisabled={disabled}
      placeholder={'Home Page'}
      options={sections ? sections.map(format) : []}
      value={selectedSection ? format(selectedSection) : null}
      {...props}
    />
  );
};

SectionSelect.propTypes = {
  value: PropTypes.number,
  import: PropTypes.number
};

export default SectionSelect;
